export default __webpack_public_path__ + "static/media/formosan-5.241ca447.jpg";